var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.listTitle,
        "show-filter": true,
        "show-refresh": true,
        "show-extract": _vm.listItems.length > 0,
        "filter-expanded": _vm.displayFilter,
        "refresh-disabled": _vm.activateSpinner,
        "extract-disabled": false,
      },
      on: {
        "toggle-filter": _vm.toggleFilter,
        refresh: _vm.onRefresh,
        extract: _vm.extractXLSX,
      },
    },
    [
      _c(
        "template",
        { slot: "filterContent" },
        [
          _c("app-panel", {
            attrs: {
              filters: _vm.filterConfig,
              searchAriaLabel:
                _vm.$t("common.srch") + " " + _vm.$t("Webheader.metricsData"),
            },
            on: {
              "filter-changed": _vm.onFilterChanged,
              "clear-filters": _vm.clearFilterFields,
              "apply-filters": _vm.onRefresh,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { staticClass: "listPage", attrs: { fluid: "" } },
            [
              _vm.tabName !== undefined
                ? _c(
                    "b-row",
                    { staticClass: "justify-content-start" },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "filter-item-action mb-5",
                          attrs: { sm: "6", lg: "3", cols: "12" },
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "filter-item-title text-ellipsis",
                              attrs: { for: "enginekey" },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("common.alerts.engine")) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.engineIndex,
                                  expression: "engineIndex",
                                },
                              ],
                              staticClass: "filter-item-content",
                              staticStyle: {
                                "max-width": "100%",
                                padding: "0.5rem",
                              },
                              attrs: { id: "enginekey", autocomplete: "off" },
                              on: {
                                change: [
                                  function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.engineIndex = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                  _vm.engineUpdate,
                                ],
                              },
                            },
                            _vm._l(_vm.engineOptions, function (engine, index) {
                              return _c(
                                "option",
                                {
                                  key: index,
                                  attrs: { disabled: engine.disabled },
                                  domProps: { value: engine.id },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(engine.name) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "filter-item-action mb-5",
                          attrs: { sm: "6", lg: "3", cols: "12" },
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "filter-item-title text-ellipsis",
                              attrs: { for: "metrickey" },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("common.alerts.metrics_key")) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.tabName,
                                  expression: "tabName",
                                },
                              ],
                              staticClass: "filter-item-content",
                              staticStyle: {
                                "max-width": "100%",
                                padding: "0.5rem",
                              },
                              attrs: { id: "metrickey", autocomplete: "off" },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.tabName = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            _vm._l(_vm.tabs, function (tab) {
                              return _c(
                                "option",
                                {
                                  key: tab.index,
                                  domProps: { value: tab.index },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(tab.translationKey) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.tabName === undefined
                ? _c("spinner")
                : _c(
                    "b-tabs",
                    {
                      attrs: { "nav-class": "d-none" },
                      on: { input: _vm.onTabChange },
                      model: {
                        value: _vm.tabName,
                        callback: function ($$v) {
                          _vm.tabName = $$v
                        },
                        expression: "tabName",
                      },
                    },
                    [
                      _vm._l(_vm.metricsKeys, function (metricsKey, index) {
                        return _c(
                          "b-tab",
                          {
                            key: metricsKey,
                            attrs: {
                              title: _vm.getMetricsKeyTranslation(metricsKey),
                            },
                          },
                          [
                            _c(
                              "b-row",
                              { staticClass: "justify-content-center mt-5" },
                              [
                                _vm.activateSpinner
                                  ? _c("spinner")
                                  : _vm.metricsChartsData[metricsKey]
                                  ? _c(
                                      "b-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c(
                                          "h2",
                                          { staticClass: "text-center" },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.getMetricsKeyTranslation(
                                                    metricsKey
                                                  )
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "chart-toggle-buttons",
                                          },
                                          [
                                            _c("app-button", {
                                              attrs: {
                                                text: _vm.$t(
                                                  "common.monitoring.line"
                                                ),
                                                variant:
                                                  _vm.chartType === "line"
                                                    ? "primary"
                                                    : "light",
                                                "custom-class": "px-4",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.chartType = "line"
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("app-button", {
                                              attrs: {
                                                text: _vm.$t(
                                                  "common.monitoring.bar"
                                                ),
                                                variant:
                                                  _vm.chartType === "bar"
                                                    ? "primary"
                                                    : "light",
                                                "custom-class": "px-4",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.chartType = "bar"
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          _vm.chartType === "line"
                                            ? "line-chart"
                                            : "bar-chart",
                                          {
                                            ref:
                                              _vm.chartType +
                                              "Chart_" +
                                              metricsKey,
                                            refInFor: true,
                                            tag: "component",
                                            staticClass: "mt-2",
                                            attrs: {
                                              "chart-data":
                                                _vm.metricsChartsData[
                                                  metricsKey
                                                ],
                                              options:
                                                _vm.chartType === "line"
                                                  ? _vm.chartOptions2
                                                  : _vm.chartOptions3,
                                              "canvas-id":
                                                _vm.chartType +
                                                "-chart-" +
                                                metricsKey,
                                            },
                                          }
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.metricsUnits, function (metricsUnit, index) {
                        return _c(
                          "b-tab",
                          {
                            key: metricsUnit,
                            attrs: {
                              title: _vm.$t(
                                "common.monitoring.resource_usage_over_time_unit",
                                { metricsUnit: metricsUnit }
                              ),
                            },
                          },
                          [
                            _c(
                              "b-row",
                              { staticClass: "justify-content-center mt-5" },
                              [
                                _vm.activateSpinner
                                  ? _c("spinner")
                                  : _vm.metricsChartsDataUnit[metricsUnit]
                                  ? _c(
                                      "b-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c(
                                          "h2",
                                          { staticClass: "text-center" },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "common.monitoring.resource_usage_over_time_unit",
                                                    { metricsUnit: metricsUnit }
                                                  )
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "chart-toggle-buttons",
                                          },
                                          [
                                            _c("app-button", {
                                              attrs: {
                                                text: _vm.$t(
                                                  "common.monitoring.line"
                                                ),
                                                variant:
                                                  _vm.chartType === "line"
                                                    ? "primary"
                                                    : "light",
                                                "custom-class": "px-4",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.chartType = "line"
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("app-button", {
                                              attrs: {
                                                text: _vm.$t(
                                                  "common.monitoring.bar"
                                                ),
                                                variant:
                                                  _vm.chartType === "bar"
                                                    ? "primary"
                                                    : "light",
                                                "custom-class": "px-4",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.chartType = "bar"
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          _vm.chartType === "line"
                                            ? "line-chart"
                                            : "bar-chart",
                                          {
                                            ref:
                                              _vm.chartType +
                                              "Chart_" +
                                              metricsUnit,
                                            refInFor: true,
                                            tag: "component",
                                            attrs: {
                                              "chart-data":
                                                _vm.metricsChartsDataUnit[
                                                  metricsUnit
                                                ],
                                              options:
                                                _vm.chartType === "line"
                                                  ? _vm.chartOptions2
                                                  : _vm.chartOptions3,
                                              "canvas-id":
                                                _vm.chartType +
                                                "-chart-unit-" +
                                                metricsUnit,
                                            },
                                          }
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }